module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-finden-circle-83ff06d5a5efd3d2730a0921bb1b1dbd.svg";